import { AnalyticsAdapter, createAnalyticsAdapter } from '@lifeway/frontend-analytics';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useCurriculum from '../../../hooks/useCurriculum';
import { ActiveCampaignAdapter } from '../adapters/activeCampaignAdapter';
import { FullStoryAdapter } from '../adapters/fullStoryAdapter';
import { IntercomAdapter } from '../adapters/intercomAdapter';
import { FullStory } from '../api/fullStory';
import { Intercom } from '../api/intercom';

const AnalyticsContext = React.createContext<AnalyticsAdapter>({} as AnalyticsAdapter);

export const AnalyticsProvider = ({ pageName, children }: { pageName: string; children: React.ReactNode }) => {
  const urlParams = useParams<{ timelineCustomizationId?: string }>();
  const curriculum = useCurriculum();

  const [analytics] = useState(() =>
    createAnalyticsAdapter({
      adapters: [
        new FullStoryAdapter(FullStory),
        new IntercomAdapter(new Intercom(window.INTERCOM_APP_ID || '')),
        new ActiveCampaignAdapter(),
      ],
    })
  );

  useEffect(() => {
    if (pageName) {
      // TODO: the calling page should use analytics.updatePage to pass this data
      const brandCode = curriculum?.brand?.code;
      const ageCategory = curriculum?.ageCategory;
      const properties: Record<string, unknown> = { brandCode, ageCategory };

      if (pageName.indexOf('BibleStudySessionTimeline') === 0) {
        properties.isCustomizedTimeline = !!urlParams?.timelineCustomizationId;
      }

      analytics.viewPage(pageName, properties);
    }
  }, [pageName, curriculum, urlParams, analytics]);

  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};

export const useAnalytics = () => {
  const analytics = React.useContext(AnalyticsContext);

  if (!analytics) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return analytics;
};
